import { render, staticRenderFns } from "./CadastroColaborador.vue?vue&type=template&id=14ad7fbe&scoped=true"
import script from "./CadastroColaborador.vue?vue&type=script&lang=js"
export * from "./CadastroColaborador.vue?vue&type=script&lang=js"
import style0 from "./CadastroColaborador.vue?vue&type=style&index=0&id=14ad7fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ad7fbe",
  null
  
)

export default component.exports